// react
import { type ReactNode } from 'react';

// components
import { CONTAINER_FULL_WIDTH_STORAGE_KEY } from '@/app/constants';
import {
  ContainerLayoutContext,
  type ContainerLayoutContextValue,
} from '@/contexts/ContainerLayoutContext';
import { useLocalStorage } from '@/hooks/useLocalStorage';

/**
 * Owns whether page-level `PageContainer`s render at `xl` width or full
 * width, persists the preference to localStorage, and exposes it app-wide
 * via context so `AppBar`'s toggle and every `PageContainer` stay in sync
 * without prop drilling.
 */
export default function ContainerLayoutProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [fullWidth, setFullWidth] = useLocalStorage(
    CONTAINER_FULL_WIDTH_STORAGE_KEY,
    true,
  );

  const toggleFullWidth = () => {
    setFullWidth((prev: boolean) => !prev);
  };

  const value: ContainerLayoutContextValue = { fullWidth, toggleFullWidth };

  return (
    <ContainerLayoutContext.Provider value={value}>
      {children}
    </ContainerLayoutContext.Provider>
  );
}
